import React, { useState, useRef } from "react";
import { usePopper } from "react-popper";
import { FaInfoCircle } from "react-icons/fa";
import styled from "styled-components";
import OutsideClickHandler from "react-outside-click-handler";

const Icon = styled.div`
  &:hover{
      cursor: pointer;
  }
`;

const DropdownContainer = styled.div`
  display: ${props => (props.visible ? "flex" : "none")};
  width: auto;
  flex-direction: column;
  border-radius: 0.2rem;
`;

const DropdownItem = styled.div`
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: ${props => props.color};
  background-color: rgb(130 130 130 / 0.1);
  padding: 0.8rem 0;
`;

const Anchor = styled.a`
  text-decoration: none;

  &:hover{
      text-decoration: underline;
  }
`;

function Dropdown({ color }) {
    const [visible, setVisibility] = useState(false);

    const referenceRef = useRef(null);
    const popperRef = useRef(null);

    const { styles, attributes } = usePopper(
        referenceRef.current,
        popperRef.current,
        {
            placement: "top-end",
            modifiers: [
                {
                    name: "offset",
                    enabled: true,
                    options: {
                        offset: [10, 10]
                    }
                }
            ]
        }
    );

    const hide = () => setVisibility(false);

    function handleDropdownClick(e) {
        e.preventDefault();
        setVisibility(true);
    }

    return (
        <OutsideClickHandler onOutsideClick={hide} >
            <Icon ref={referenceRef} onClick={handleDropdownClick} >
                <FaInfoCircle fontSize='1.4rem' color={color} />
            </Icon>
            <div ref={popperRef} style={styles.popper} {...attributes.popper}>
                <DropdownContainer style={styles.offset} visible={visible}>
                    <DropdownItem color={color}> Image by
                        <Anchor style={{ color }} href='https://unsplash.com/@echogrid' target='_blank' rel='noreferrer'> @echogrid</Anchor>
                        <span> from</span>
                        <Anchor style={{ color }} href='https://www.unsplash.com' target='_blank' rel='noreferrer'> unsplash.com</Anchor>
                    </DropdownItem>
                </DropdownContainer>
            </div>
        </OutsideClickHandler >
    );
}

export default Dropdown;
